import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiMail, FiMessageCircle } from 'react-icons/fi';

const Kontakt = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setTimeout(() => setSubmitted(true), 500);
  };

  return (
    <div className="bg-slate-50 min-h-screen py-16 md:py-24">
      <div className="container-custom max-w-6xl">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold mb-4">Kontakt</h1>
          <p className="text-lg text-slate-600">Hast du Fragen zur Vermittlung? Schreib uns gerne eine Nachricht.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16 max-w-4xl mx-auto">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 text-center">
            <div className="w-12 h-12 bg-teal-50 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiMail} className="text-xl" />
            </div>
            <h3 className="font-bold mb-2">E-Mail</h3>
            <a href="mailto:info@nebenjob-nord.de" className="text-slate-600 hover:text-teal-600">info@nebenjob-nord.de</a>
          </div>
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 text-center">
            <div className="w-12 h-12 bg-teal-50 text-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiMapPin} className="text-xl" />
            </div>
            <h3 className="font-bold mb-2">Standort</h3>
            <p className="text-slate-600">Axel-Springer-Platz 3<br/>20355 Hamburg</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden max-w-3xl mx-auto">
          <div className="p-8 md:p-10">
            <h2 className="text-2xl font-bold mb-6">Nachricht senden</h2>
            
            {submitted ? (
              <div className="bg-teal-50 text-teal-800 p-6 rounded-lg text-center">
                <SafeIcon icon={FiMessageCircle} className="text-4xl mx-auto mb-3 text-teal-600" />
                <h3 className="font-bold text-lg mb-2">Nachricht erfolgreich gesendet</h3>
                <p>Vielen Dank für deine Kontaktaufnahme. Wir melden uns schnellstmöglich bei dir.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Name</label>
                    <input type="text" required className="w-full px-4 py-3 border border-slate-300 rounded-md focus:ring-teal-500 focus:border-teal-500" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">E-Mail</label>
                    <input type="email" required className="w-full px-4 py-3 border border-slate-300 rounded-md focus:ring-teal-500 focus:border-teal-500" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Betreff</label>
                  <select className="w-full px-4 py-3 border border-slate-300 rounded-md focus:ring-teal-500 focus:border-teal-500 bg-white">
                    <option>Frage als Bewerber</option>
                    <option>Frage als Unternehmen</option>
                    <option>Sonstiges</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Nachricht</label>
                  <textarea rows="5" required className="w-full px-4 py-3 border border-slate-300 rounded-md focus:ring-teal-500 focus:border-teal-500"></textarea>
                </div>
                <button type="submit" className="w-full btn-primary py-4">
                  Nachricht absenden
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kontakt;